<template>
  <i
    class="lv-icon"
    :class="[icon, color]"
    :style="{
      'font-size': `${size}`,
    }"
  />
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    size: {
      type: String,
    },
    color: {
      type: String,
    },
  },
};
</script>
